"use client"

import Image from "next/image"
import Link from "next/link"

import termsemailicon from "@/assets/termsemailicon.png"
import termsurlicon from "@/assets/termsurlicon.png"

export default function PageClient() {
  return (
    <div className="px-3 pt-4 text-[#1D2129] sm:px-[120px] sm:pt-[56px]">
      <div className="mb-3 text-[24px] font-bold sm:text-[32px]">
        Terms of Use
      </div>
      <div className="mb-3 text-[14px] text-[#4E5969]">
        Effective Date: 08/06/2025
      </div>
      <div className="mb-3 text-[14px] text-[#4E5969]">
        Welcome to SnapThePrice.com (“we”, “our”, or “us”). These Terms of Use
        (“Terms”) govern your access to and use of our website and browser
        <br />
        extension (collectively, the “Service”), including our AI-powered
        shopping assistant and real-time price comparison tools.
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        By accessing or using the Service, you agree to be bound by these Terms.
        If you do not agree, please do not use the Service.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        1. Description of Service
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        SnapThePrice is an AI-powered shopping assistant designed to help users
        discover lower prices, compare products across online retailers, and
        make more informed shopping decisions. The Service includes a browser
        extension and website functionalities, which may include affiliate links
        and personalized recommendations.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        2. User Eligibility
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        You must be at least 18 years old or the age of majority in your
        jurisdiction to use the Service. By using the Service, you represent and
        warrant that you meet these requirements.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        3. User Responsibilities
      </div>
      <div className="mb-2 text-[14px] text-[#4E5969] sm:mb-[12px]">
        When using SnapThePrice, you agree to:
      </div>
      <ul className="list-disc pl-5 text-[14px] text-[#4E5969]">
        <li className="mb-1">
          Use the Service only for personal, non-commercial purposes;
        </li>
        <li className="mb-1">
          Not interfere with the operation or security of the Service;
        </li>
        <li className="mb-1">
          Not misuse or attempt to reverse engineer any part of our AI
          technology or extension;
        </li>
        <li className="mb-1 sm:mb-[40px]">
          Provide accurate information if prompted, such as during registration.
        </li>
      </ul>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        4. AI-Generated Content Disclaimer
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        Our AI assistant provides suggestions and recommendations based on
        available data and algorithms. While we strive for accuracy, we do not
        guarantee the completeness, accuracy, or suitability of any AI-generated
        content, including product comparisons or recommendations. Use your own
        judgment before making a purchase.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        5. Affiliate Disclosure
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        SnapThePrice may earn a commission when you purchase through affiliate
        links on our site or browser extension. This comes at no extra cost to
        you and supports the ongoing development of our free services. We always
        aim to remain unbiased in our recommendations.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        6. Privacy
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        Our collection and use of personal data is governed by our Privacy
        Policy. By using the Service, you consent to the practices described in
        the{" "}
        <span className="cursor-pointer text-[#135BFF]">Privacy Policy.</span>
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        7. Intellectual Property
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        All content, features, and functionality on the Service — including
        text, graphics, logos, software, and AI components — are the property of
        SnapThePrice or its licensors and are protected by intellectual property
        laws. You may not copy, modify, distribute, or exploit any part of the
        Service without our written permission.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        8. Termination
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        We reserve the right to suspend or terminate your access to the Service
        at our sole discretion, without notice, for conduct that we believe
        violates these Terms or is harmful to other users, us, or third parties.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        9. Limitation of Liability
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        To the fullest extent permitted by law, SnapThePrice shall not be liable
        for any indirect, incidental, consequential, or punitive damages,
        including lost profits or data, arising out of your use or inability to
        use the Service.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        10. Changes to These Terms
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        We may update these Terms from time to time. If we make material
        changes, we’ll notify you through the Service or by other means.
        Continued use of the Service after changes take effect means you accept
        the new Terms.
      </div>
      <div className="mb-1 text-[18px] font-bold sm:text-[24px]">
        11. Contact Us
      </div>
      <div className="mb-5 text-[14px] text-[#4E5969] sm:mb-[40px]">
        If you have any questions about these Terms, please contact us at:
      </div>
      <div className="mb-3 flex items-center gap-3">
        <Image
          src={termsemailicon}
          alt="termsemailicon"
          width={20}
          height={20}
        />
        <div className="text-[14px] text-[#135BFF]">
          support@snaptheprice.com
        </div>
      </div>
      <div className="flex items-center gap-3">
        <Image src={termsurlicon} alt="termsurlicon" width={20} height={20} />
        <div className="cursor-pointer text-[14px] text-[#135BFF]">
          www.snaptheprice.com
        </div>
      </div>
    </div>
  )
}
